/** @jsxImportSource @emotion/react */
import { withMyTheme } from "../../theme/theme"
import { css } from "@mui/material"
import { Button, Box } from "@mui/material"
import { useTranslation } from "react-i18next"
import { mobileCss } from "../../util/isMobile"

interface MobileNavigationButtonsProps {
    currentStep: number
    totalSteps: number
    onPreviousStep: () => void
    onNextStep: () => void
}

const MobileNavigationStyle = withMyTheme((theme) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 4vh;
    gap: 1rem;
`)

const NavigationButtonStyle = withMyTheme((theme) => css`
    flex: 1;
    padding: 12px 24px;
    border-radius: 12px;
    font-weight: 600;
    text-transform: none;
    font-size: 1rem;
    
    &:disabled {
        opacity: 0.5;
    }
`)

export const MobileNavigationButtons = ({ 
    currentStep, 
    totalSteps, 
    onPreviousStep, 
    onNextStep 
}: MobileNavigationButtonsProps) => {
    const { t } = useTranslation()
    
    return (
        <Box css={MobileNavigationStyle}>
            <Button
                variant="outlined"
                css={NavigationButtonStyle}
                onClick={onPreviousStep}
                disabled={currentStep <= 1} // Disable on first actual step (after intro)
            >
                {t('questionnaire.navigation.previous')}
            </Button>
            <Button
                variant="contained"
                css={NavigationButtonStyle}
                onClick={onNextStep}
                disabled={currentStep >= totalSteps - 1} // Disable on last step
            >
                {t('questionnaire.navigation.next')}
            </Button>
        </Box>
    )
}
